import React, { useEffect, useState } from "react";
import GenericCarousel from "../../../common/elements/GenericCarousel";
import { useMediaQuery } from "@material-ui/core";
import styled from "styled-components";

const StyledImageContainer = styled.img<{ isMobile: boolean }>`
  width: auto;
  height: ${(props) => (props.isMobile ? "70vh" : "400px")};
  ${(props) => props.theme.breakpoints.between("xs", "sm")} {
    padding: 10px;
    width: 100%;
    height: 60vh;
  }
  @media (min-width: 768px) and (max-width: 830px) {
    width: 85%;
  }
`;

const StyledDiv = styled.div<{ isMobile: boolean }>`
  display: flex;
  justify-content: center;
  height: ${(props) => (props.isMobile ? "70vh" : "400px")};
  ${(props) => props.theme.breakpoints.between("xs", "sm")} {
    height: 60vh;
  }
`;

const StyledHeroContainer = styled.div<{ isMobile: boolean }>`
  height: ${(props) => (props.isMobile ? "70vh" : "430px")};
  min-width: 100%;
  max-width: 100%;
  position: relative;
  margin-top: ${(props) => (props.isMobile ? "10px" : "0")};
  margin-bottom: ${(props) => (props.isMobile ? "2em" : "0")};
`;

const StyledCarouselContainer = styled.div`
  position: absolute;
  top: 0;
  width: 50%;
  z-index: 999;
  ${(props) => props.theme.breakpoints.between("xs", "sm")} {
    width: auto;
  }

  @media (min-width: 768px) and (max-width: 830px) {
    width: 80%;
  }
`;

const StyledImage = ({
  src = "",
  alt = "carouselstyledimage",
  mobileSrc = "",
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  return (
    <StyledDiv isMobile={isMobile}>
      <StyledImageContainer
        isMobile={isMobile}
        src={isMobile ? mobileSrc : src}
        alt={alt}
      />
    </StyledDiv>
  );
};

const heroImages = [
  // {
  //   alt: "aug image #1",
  //   src: "https://ds29nc3ljdjce.cloudfront.net/thejewels/August.png",
  //   mobileSrc: "https://ds29nc3ljdjce.cloudfront.net/thejewels/August.png",
  // },
  // {
  //   alt: "sep image #1",
  //   src: "https://ds29nc3ljdjce.cloudfront.net/thejewels/September.png",
  //   mobileSrc: "https://ds29nc3ljdjce.cloudfront.net/thejewels/September.png",
  // },
  // {
  //   alt: "oct image #1",
  //   src: "https://ds29nc3ljdjce.cloudfront.net/thejewels/October.png",
  //   mobileSrc: "https://ds29nc3ljdjce.cloudfront.net/thejewels/October.png",
  // },
  {
    alt: "nov image #1",
    src: "https://ds29nc3ljdjce.cloudfront.net/thejewels/November.png",
    mobileSrc: "https://ds29nc3ljdjce.cloudfront.net/thejewels/November.png",
  },
  // {
  //   alt: "dec image #1",
  //   src: "https://ds29nc3ljdjce.cloudfront.net/thejewels/December.png",
  //   mobileSrc: "https://ds29nc3ljdjce.cloudfront.net/thejewels/December.png",
  // }
];

const ZipangUpcomingAuc = ({
  isMobile,
  inViewRef,
}: {
  isMobile: boolean;
  inViewRef: React.Ref<any>;
}) => {
  const [slideNumber, setSlideNumber] = useState(0);

  const handleCarouselSlideChange = (slideNumber: number) =>
    setSlideNumber(slideNumber);

  useEffect(() => {
    trialModalHandler();
  }, []);

  const trialModalHandler = () => {
    let modalDisplayed = localStorage.getItem("modalDisplayed");
    !modalDisplayed &&
      setTimeout(() => {
        localStorage.setItem("modalDisplayed", "1");
      }, 4000);
  };

  return (
    <StyledHeroContainer
      isMobile={isMobile}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <StyledCarouselContainer>
        <GenericCarousel
          navButtonsAlwaysVisible={true}
          indicators={heroImages.length > 1}
          onChange={handleCarouselSlideChange}
        >
          {heroImages.map((item, i) => (
            <StyledImage
              key={i}
              src={item.src}
              mobileSrc={item.mobileSrc}
              alt={item.alt}
            />
          ))}
        </GenericCarousel>
      </StyledCarouselContainer>
    </StyledHeroContainer>
  );
};

export default ZipangUpcomingAuc;
